export default __webpack_public_path__ + "static/media/jojoLogo.d2abefc4.jpg";